var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNineSmallBoxesSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47.284 47.284",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M13.113,0.27H1.559C0.698,0.27,0,0.967,0,1.828v11.567c0,0.861,0.697,1.558,1.559,1.558h11.555 c0.861,0,1.559-0.697,1.559-1.558V1.828C14.672,0.967,13.975,0.27,13.113,0.27z M11.555,11.837H3.117V3.386h8.438V11.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M13.113,16.164H1.559C0.698,16.164,0,16.861,0,17.723v11.57c0,0.861,0.697,1.558,1.559,1.558 h11.555c0.861,0,1.559-0.697,1.559-1.558v-11.57C14.672,16.862,13.975,16.164,13.113,16.164z M11.555,27.735H3.117v-8.454h8.438 V27.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M13.113,32.596H1.559C0.698,32.596,0,33.293,0,34.154v11.57c0,0.861,0.697,1.559,1.559,1.559 h11.555c0.861,0,1.559-0.697,1.559-1.559v-11.57C14.672,33.293,13.975,32.596,13.113,32.596z M11.555,44.166H3.117v-8.454h8.438 V44.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M29.418,0.001H17.863c-0.859,0-1.557,0.697-1.557,1.558v11.569c0,0.861,0.697,1.558,1.557,1.558 h11.555c0.861,0,1.559-0.697,1.559-1.558V1.559C30.976,0.698,30.279,0.001,29.418,0.001z M27.861,11.57h-8.439V3.117h8.439V11.57z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M29.418,15.895H17.863c-0.859,0-1.557,0.697-1.557,1.558v11.568c0,0.861,0.697,1.558,1.557,1.558 h11.555c0.861,0,1.559-0.697,1.559-1.558V17.453C30.976,16.592,30.279,15.895,29.418,15.895z M27.861,27.464h-8.439v-8.452h8.439 V27.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M29.418,32.328H17.863c-0.859,0-1.557,0.697-1.557,1.558v11.568c0,0.861,0.697,1.558,1.557,1.558 h11.555c0.861,0,1.559-0.697,1.559-1.558V33.887C30.976,33.025,30.279,32.328,29.418,32.328z M27.861,43.897h-8.439v-8.452h8.439 V43.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M45.725,0.002H34.17c-0.861,0-1.559,0.697-1.559,1.558v11.569c0,0.861,0.697,1.558,1.559,1.558 h11.555c0.861,0,1.559-0.697,1.559-1.558V1.56C47.283,0.7,46.586,0.002,45.725,0.002z M44.166,11.571h-8.438V3.118h8.438V11.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M45.725,15.898H34.17c-0.861,0-1.559,0.697-1.559,1.558v11.568c0,0.861,0.697,1.558,1.559,1.558 h11.555c0.861,0,1.559-0.697,1.559-1.558V17.456C47.283,16.595,46.586,15.898,45.725,15.898z M44.166,27.467h-8.438v-8.453h8.438 V27.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M45.725,32.33H34.17c-0.861,0-1.559,0.697-1.559,1.558v11.568c0,0.861,0.697,1.558,1.559,1.558 h11.555c0.861,0,1.559-0.697,1.559-1.558V33.888C47.283,33.027,46.586,32.33,45.725,32.33z M44.166,43.898h-8.438v-8.452h8.438 V43.898z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNineSmallBoxesSvgrepoCom);
export default __webpack_public_path__ + "static/media/nine-small-boxes-svgrepo-com.2c02e57200a2fcd59e093778a6131d28.svg";
export { ForwardRef as ReactComponent };